import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function DataDeletionPage() {
  return (
    <LegalLayout
      title="Account & data deletion"
      subtitle="How to permanently delete your Daywia account and associated data."
    >
      <LegalSection title="Overview">
        <LegalP>
          You can delete your {OPERATOR.product} account at any time. Deletion is permanent and
          removes your profile, posts, payment history, chat history, and media stored on our
          servers (Cloudflare R2). This cannot be undone.
        </LegalP>
      </LegalSection>

      <LegalSection title="Delete in the Android app">
        <LegalUl
          items={[
            "Open Settings (from your profile or navigation drawer).",
            "Go to Support → FAQ.",
            "Tap Delete account and confirm both prompts.",
            "You will be signed out immediately; deletion runs on our servers.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Delete on the web">
        <LegalP>
          Sign in at daywia.com, open Settings → FAQ (when available on web), and follow Delete
          account. If the web client does not yet expose deletion, use the Android app or email{" "}
          <a href={`mailto:${CONTACT.support}`} className={tw.link}>
            {CONTACT.support}
          </a>{" "}
          from your registered email with subject &quot;Delete my Daywia account&quot;.
        </LegalP>
      </LegalSection>

      <LegalSection title="What is deleted">
        <LegalUl
          items={[
            "Profile (name, bio, avatar, mobile number on file).",
            "Posts: Frames, Drifts, Parallel content and captions.",
            "Comments, reactions, notifications, and chat messages.",
            "Payment, tip, and subscription records tied to your account.",
            "Media files on our CDN linked to your user ID.",
            "Contact-sync hashes associated with your account.",
          ]}
        />
      </LegalSection>

      <LegalSection title="What may remain briefly">
        <LegalP>
          Anonymized analytics, security logs, and payment records required by law or Cashfree may
          be retained for a limited period. Backups may take up to 30 days to fully purge.
        </LegalP>
      </LegalSection>

      <LegalSection title="Export before deleting">
        <LegalP>
          You may request a copy of your data before deletion via the privacy export feature in
          the app or by emailing{" "}
          <a href={`mailto:${CONTACT.help}`} className={tw.link}>
            {CONTACT.help}
          </a>
          . See our{" "}
          <Link to="/privacy" className={tw.link}>
            Privacy Policy
          </Link>{" "}
          for details.
        </LegalP>
      </LegalSection>

      <LegalSection title="Need help?">
        <LegalP>
          Contact{" "}
          <a href={`mailto:${CONTACT.support}`} className={tw.link}>
            {CONTACT.support}
          </a>{" "}
          or visit our{" "}
          <Link to="/contact" className={tw.link}>
            Contact
          </Link>{" "}
          page.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
